/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelGeographicCity.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/geographic-city";

export class AutogenModelGeographicCity<RowType extends ModelRow> extends Endpoint<RowType, RowGeographicCityFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowGeographicCity extends ModelRow<RowGeographicCityFields> {
	constructor(values?: Partial<RowGeographicCityFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowGeographicCityFields {
	airport_code: string;
	alk_id: number;
	central_location: string;
	company_id: string;
	county: string;
	id: number;
	inactive: string;
	isi_id: number;
	latitude: number;
	longitude: number;
	name: string;
	pcm_window_city_id: number;
	rmm_id: number;
	state_id: string;
	three_digit_zip: string;
	timezone_id: string;
	zip_code: string;
	zone_id: string;
}

